import { atom } from 'recoil';

export const calendarSelectdDateState = atom<any>({
  key: 'calendarSelectdDateState',
  default: new Date(),
});

export const calendarSelectedItemIdState = atom<string>({
  key: 'calendarSelectedItemIdState',
  default: '',
});
